<template>
  <div>
    <div class="container-table-striped">
      <div class="table-hover">
        <table class="table content-table-striped table-striped">
          <thead>
            <tr class="row global-thead-dark thead-property pl-1">
              <th class="col-4">
                Áreas
              </th>
              <th class="col-8">
                Acomodos
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" :key="row.id" class="row pl-2">
              <td class="col-md-4">
                <span>{{ row.area }}</span>
              </td>
              <td class="col-md-8 pl-3">
                <BadgeTitle
                  v-for="item in row.accommodations"
                  :key="item.id"
                  :title="item.title"
                  @delete="deleteClick(index, item)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="float-right">
        <button
          type="button"
          class="btn btn-green drop-item float-right"
          @click="addClick"
        >
          <i class="fas fa-file-plus text-white pr-2" />
          <span class="text-white">Añadir</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { BadgeTitle } from '@/components/pei/shared';
export default {
  name: 'LearningAccommodationStudent',
  props: {
    rows: {
      type: Array,
      required: true,
    },
  },
  methods: {
    addClick() {
      this.$emit('on-add');
    },
    deleteClick(index, item) {
      this.$emit('unselect-item', { index: index, item: { ...item } });
    },
  },
  components: {
    BadgeTitle,
  },
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.btn-success-outline {
  height: 38px;
  border: 1px solid #2db782 !important;
  color: #2db782;
}

.btn-success-outline:hover {
  background: #2db782;
  border: 1px solid #2db782;
  color: #fff;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}
</style>
